import React, { Component } from 'react';
//import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, Cell, DataTable, DialogContainer, Grid, TableBody, TableColumn, TableHeader, TableRow, TextField } from 'react-md';
//import instructorStyles from '../css/instructorStyles.css.js';
import { NotificationManager } from 'react-notifications';
import ApiRequestService from '../component/ApiRequestService';
//import { browserHistory } from 'react-router'
import styles from '../css/styles.css.js';

/*
let newUniversityObject = {
    univFullName: '',
    univName:'',
    univPort: 0,
    univSubjectId: 0,
}*/
export default class NewUniversityForm extends Component {

    constructor(props){
        super(props);
        this.state = {
          universities: [],
          newUniversity: {},
          visible: false,
          addMode : true,
        };


        this.addUniversity = this.addUniversity.bind(this);
        this.changeNewUnivName = this.changeNewUnivName.bind(this);
        this.changeNewUnivFullName = this.changeNewUnivFullName.bind(this);

    }

    componentWillMount(){
        ApiRequestService({
            method: 'post',
            url: '/getAllUniversities'
        })
        .then(res => {
            if (res.data.data !== undefined && res.data.data !== null){
                console.debug(res.data.data)
            this.setState({
                universities: res.data.data
            });
            }else{
                NotificationManager.error(res.data.message,'Error - No Univeristy Found',10000);
            }
        })
    }


    addUniversity(){
        console.log("Add New university :" , this.state.newUniversity, this.state.newUniversity.univFullName);
        
        ApiRequestService({
            method: 'post',
            url:  '/createNewUniversity',
            data: {
                    ...this.state.newUniversity,
                    isCpanelClient: 1,
                    isStudentClient: 1,
                    isServer: 1,
                    isRemoveContainer:0
                  }

        }).then(res => {
            console.log("Add new university response : ",res);
            if( res.data.status !== 0){
                NotificationManager.error(res.data.message,'Error - University Not Added',10000);
            }
            let tempUniversities = [];
            if(this.state.universities){
                tempUniversities = this.state.universities;
            }
            tempUniversities.pop()
            
            this.setState({
                universities: tempUniversities
            })
        })
        let tempUniversities = [];
        if(this.state.universities){
            tempUniversities = this.state.universities;
        }
        tempUniversities.push({
            univName:  this.state.newUniversity.univName,

            univFullName: this.state.newUniversity.univFullName,
            univPort: '-',
            univSubjectId: '-',
            status: 'Deploying'
        });
        this.setState({
            universities: tempUniversities
        })
        this.hide()
    }


    changeNewUnivFullName(fullname) {
        let temp_newUniv =   this.state.newUniversity;
        temp_newUniv.univFullName =  fullname
        this.setState({
            newUniversity: temp_newUniv
        });
    }

    changeNewUnivName(univName) {
        let temp_newUniv =   this.state.newUniversity;
        temp_newUniv.univName =  univName
        this.setState({
            newUniversity: temp_newUniv
        });
    }

    show = () => {
        this.setState({ 
            newUniversity: {}, 
            visible: true });
      };

    hide = () => {
        this.setState({  
            visible: false,
            addMode: true,
            newUniversity: {}, 
        });
    };

    render() {

        let button = <button style= {styles.addButton} onClick = {this.addUniversity}>Add University</button>
        
        var cancelButton = <button style= {styles.cancelButton} onClick = {this.hide}>Cancel</button>

        const actions = [];
        actions.push(button);
        actions.push(cancelButton);

        return ([
            
            <Grid key="universityTable">
                    <Cell size={12} className="semester-title">
                        <h3>All Universities in Stemfluency</h3>
                        <Button 
                        style={{background: "transparent",border: "none"}}
                        onClick={this.show}>
                        Add a New University
                        </Button>
                    </Cell>
                    <Cell size={12}  className="semester-table-container">
                        <UniversitiesList universities={this.state.universities} />
                    </Cell>
                </Grid>,
                <DialogContainer
                        id="simple-action-dialog"
                        visible={this.state.visible}
                        onHide={this.hide}
                        actions={actions}
                        //title="New Instructor"
                        width="500px"
                        key="AddNewUniversityDialog"
                        >
                <h2><label for="instrId">New University</label></h2>
                <TextField 
                    value={this.state.newUniversity.univFullName} 
                    onChange={this.changeNewUnivFullName} 
                    id="univFullName" 
                    label="University Full Name" 
                    placeholder="Enter the Full Name of the university..." 
                    className="md-cell md-cell--12" 
                />
                <TextField 
                    value={this.state.newUniversity.univName} 
                    onChange={this.changeNewUnivName} 
                    id="univName" 
                    label="Email prefix" 
                    placeholder="Enter a Email prefix of the University..." 
                    className="md-cell md-cell--12" 
                    helpText="Eg: asu if email domain is asu.edu."
                    errorText="This field is required."
                />
                </DialogContainer> 

            ]);
     }
}

var UniversitiesList = (props) => {

    
    if(props.universities){
        return <DataTable plain>
            <TableHeader>
                <TableRow>    
                    <TableColumn>University Full Name</TableColumn>
                    <TableColumn>Email Prefix</TableColumn>
                    <TableColumn>University Port</TableColumn>
                    <TableColumn>University Subject Id</TableColumn>
                    <TableColumn>Status</TableColumn>
                </TableRow>
            </TableHeader>
            <TableBody>
                {Object.values(props.universities).map((university, index) => (
                    <TableRow key={"university"+index}>
                        <TableColumn>{university.univFullName}</TableColumn>
                        <TableColumn>{university.univName}</TableColumn>
                        <TableColumn>{university.univPort}</TableColumn>
                        <TableColumn>{university.univSubjectId}</TableColumn>
                        <TableColumn>{university.status}</TableColumn>
                    </TableRow>
                ))} 
            </TableBody>
        </DataTable>
    }
  
    return null;
}
